import Vue from 'vue'
import Vuex from 'vuex'
import cookie from '@assets/js/public/Cookie'
import {getCityInfo, setCityInfo} from "@/utils/auth";


Vue.use(Vuex)
// if (!getCityInfo('cityInfo')) {
//     const cityArr={
//         regionalId: '',
//         regionalName: '',
//         mailType:'',
//     }
//     const cityJson=JSON.stringify(cityArr)
//     setCityInfo('cityInfo',cityJson)
// }

export default new Vuex.Store({
    state: {
        loginStatus: cookie.loginState(),
        cityInfo:{
            regionalId:getCityInfo('cityInfo')? JSON.parse(getCityInfo('cityInfo')).regionalId: '',
            regionalName:getCityInfo('cityInfo')? JSON.parse(getCityInfo('cityInfo')).regionalName: '',
        },
        mailType:''
    },
    mutations: {
        LOGIN_SWITCH(state, status) {
            state.loginStatus = status
        },
        GET_CITY(state,status){
            state.cityInfo=status
        },
        GET_MAILTYPE(state,status){
            state.mailType=status
        }
    },
    actions: {}
})
